import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

//import JoditEditor from "jodit-react";

import { /*object_type,*/ api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {

	reqGET,
	reqPOST,
	//reqDELETE,
	//reqPUT,
	content_language,

} from '../../../Utils';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const produtos = useRef(null);
	const forfaits = useRef(null);
	const equipamentos = useRef(null);
	const aulas = useRef(null);
	const atividades = useRef(null);
	const packs = useRef(null);
	const order = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	//const [show_delete_button, set_show_delete_button] = useState(false);

	const [selected_products, set_selected_products] = useState([]);

	/*const editor = useRef(null)
	const config = {
        readonly: false // all options from https://xdsoft.net/jodit/doc/
    }*/

	//const [disabled, set_disabled] = useState(true)

	//const [is_edit, set_is_edit] = useState(false)

	const fetch_id_info = async (id_serch) => {

		await reqGET(`${api_crud_base}/estancia/product/${getTokenInfo().companycode}`)
		.then(res => {
			set_dados(produtos.current = res.data);
		})
		.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

		await reqGET(`${api_crud_base}/estancia/forfait/${getTokenInfo().companycode}`)
			.then(res => {
				set_dados(forfaits.current = res.data);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

		await reqGET(`${api_crud_base}/estancia/equipamento/${getTokenInfo().companycode}`)
			.then(res => {
				set_dados(equipamentos.current = res.data);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

		await reqGET(`${api_crud_base}/estancia/pack/${getTokenInfo().companycode}`)
			.then(res => {
				set_dados(packs.current = res.data);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

		await reqGET(`${api_crud_base}/estancia/activity/${getTokenInfo().companycode}`)
			.then(res => {
				set_dados(atividades.current = res.data);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

		await reqGET(`${api_crud_base}/estancia/aula/info/${getTokenInfo().companycode}`)
			.then(res => {
				set_dados(aulas.current = res.data);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

		return await reqGET(`${api_crud_base}/entities/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);

				let user_info_aux = {
					id_user: id_serch,
					username: res.data[0].info.username, 
					name: res.data[0].info.name,
					vat: res.data[0].info.vat,
					addresses: res.data[0].addresses,
					contacts: res.data[0].contacts,
					obs: '',
				}

				set_dados(order.current.info.documento.user_info = user_info_aux);

				// console.log('user_info_aux', user_info_aux)

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {

		let date_today = new Date()
		let id_pagamento = Date.now() + '' + props.location.state.item['id']

		// DEEP COPY OF data_interface 
		set_dados(order.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(order.current.info.companycode = getTokenInfo().companycode)

		set_dados(order.current.info.data = date_today.getFullYear() + '-' + (date_today.getMonth() + 1).toString().padStart(2, '0') + '-' + date_today.getDate().toString().padStart(2, '0'))
		set_dados(order.current.info.timestamp = date_today)
		set_dados(order.current.info['id_usado_para_gerar_pagamento'] = parseInt(id_pagamento))
		//console.log(dados.current)

	}

	useEffect(() => {


		clean_data();

        set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//set_disabled(true)

				//set_is_edit(true)

				//set_show_delete_button(true)



				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)

					// console.log('forfaits', forfaits.current)
					// console.log('equipamentos', equipamentos.current)
					// console.log('packs', packs.current)
					// console.log('atividades', atividades.current)
					// console.log('aulas', aulas.current)
				})
				return
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props])

	let get_total_iva_documento = (linhas) => {

		let tmp_total_iva = 0.00
		linhas.forEach(linha => {
			//let v_tmp_iliq = parseFloat(linha.total_iliquido_com_desconto) - parseFloat(valor_desconto_global_a_aplicar)
			//let v_tmp_iva = parseFloat(v_tmp_iliq) * parseFloat(linha.taxa_iva) * 0.01
			//tmp_total_iva += parseFloat(v_tmp_iva)
			tmp_total_iva += parseFloat(linha.total_iva)
		})

		return tmp_total_iva
	}

	const handleSubmit = async e => {
		e.preventDefault();

		let linhas_aux = []
		let i = 0

		let p_total_aux = 0.00
		//let p_subtotal_aux = 0.00

		let p_total_iliquido_documento = 0.00
		let p_total_desconto_linha_documento = 0.00
		let p_taxa_desconto_global = 0.00
		//let p_valor_desconto_global_a_aplicar = 0.00
		let p_total_iliquido_documento_com_deconto_linha_e_global = 0.00

		//let p_total_documento = 0.00

		let p_tem_aulas = false

		selected_products.forEach(el => {
			console.log('el', el)

			let p_aux = produtos.current.filter(el_p => el_p.id === el.id)

			console.log('p_aux', p_aux)

			if(p_aux !== undefined && p_aux !== null && p_aux.length === 1) {

				let prod_aux = {}

				let p_id = p_aux[0].id
				let p_pretence_ao_produto = p_aux[0].id
				// let p_name = p_aux[0].info.name + (p_aux[0].info.category !== '' ? ' - ' + p_aux[0].info.category : '')
				let p_name = p_aux[0].info.name
				let p_subname = ''
				let p_observation = p_aux[0].info.observation
				let p_taxa_iva = 0
				let p_total_iva = 0.00
				let p_total_com_iva = 0.00
				let p_total_liquido = 0.00
				let p_preco_unitario = 0.00
				let p_total_desconto = 0.00
				let p_total_iliquido = 0.00
				let p_taxa_desconto_linha = 0.00
				let p_total_iva_apresentado = 0.00
				let p_total_com_iva_apresentado = 0.00
				let p_total_iliquido_apresentado = 0.00
				let p_total_iliquido_com_desconto = 0.00

				if(p_aux[0].info['type'] !== undefined && p_aux[0].info['type'] !== null && p_aux[0].info['type'] === 'pack') {
					prod_aux = {}
					p_subname = ''
					p_observation = ''

					if(p_aux[0].info['forfait'].id !== '') {

						let f_aux = produtos.current.filter(el_p => el_p.id === p_aux[0].info['forfait'].id)

						console.log('f_aux', f_aux)

						if(f_aux !== undefined && f_aux !== null && f_aux.length === 1) {

							// FORFAIT
							p_id = f_aux[0].id
							p_subname = f_aux[0].info.name + (f_aux[0].info.category !== '' ? ' - ' + f_aux[0].info.category : '')
							p_observation = (p_aux[0].info['detail'] !== undefined && p_aux[0].info['detail']['pessoas'] !== undefined && parseInt(p_aux[0].info['detail']['pessoas']) > 1 ? p_aux[0].info['detail']['pessoas'] + ' x ' : '') + f_aux[0].info.name

							p_preco_unitario = parseFloat(f_aux[0].info.forfait.price_s_vat)
							p_taxa_iva = f_aux[0].info.forfait.taxe
							p_total_iliquido = parseFloat((parseFloat(p_preco_unitario)) * el.qtd)

							p_total_desconto = 0.00
							p_taxa_desconto_linha = 0.00
							p_total_iliquido_com_desconto = (parseFloat(p_total_iliquido) - parseFloat(p_taxa_desconto_linha))

							p_total_iva = (parseFloat(p_total_iliquido) * parseFloat(p_taxa_iva) * 0.01)
							p_total_com_iva = (parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva))

							p_total_iva_apresentado = (((parseFloat(f_aux[0].info.forfait.price) - parseFloat(f_aux[0].info.forfait.price_s_vat)) * parseInt(el.qtd))).toFixed(2)

							p_total_iliquido_apresentado = parseFloat(p_total_iliquido).toFixed(2)
							p_total_com_iva_apresentado = parseFloat(f_aux[0].info.forfait.price).toFixed(2)

							p_total_aux += parseFloat(f_aux[0].info.forfait.price) * parseInt(el.qtd)
							p_total_iliquido_documento += parseFloat(p_total_iliquido)
							p_total_iliquido_documento_com_deconto_linha_e_global += parseFloat(p_total_iliquido_com_desconto)
							
							p_total_liquido = parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva)

							prod_aux = {
								subname: p_subname,
								observation: p_observation,
								unidade: 'un',
								taxa_iva: p_taxa_iva,
								total_iva: parseFloat(p_total_iva),
								designacao: p_name,
								id_produto: p_id,
								quantidade: parseInt(el.qtd),
								aula_marcada: '',
								total_com_iva: parseFloat(p_total_com_iva),
								total_liquido: parseFloat(p_total_liquido),
								preco_unitario: parseFloat(p_preco_unitario),
								total_desconto: parseFloat(p_total_desconto),
								total_iliquido: parseFloat(p_total_iliquido),
								pretence_ao_produto: p_pretence_ao_produto,
								taxa_desconto_linha: parseFloat(p_taxa_desconto_linha),
								total_iva_apresentado: p_total_iva_apresentado,
								total_com_iva_apresentado: p_total_com_iva_apresentado,
								id_produto_na_lista_linhas: ++i,
								total_iliquido_apresentado: p_total_iliquido_apresentado,
								total_iliquido_com_desconto: parseFloat(p_total_iliquido_com_desconto),
								quantidade_aux_em_caso_de_aula: 0,
							}

							linhas_aux.push(prod_aux)

							// ALUGUE DE PISTA
							p_id = '90'
							p_subname = 'Aluguer de Pista'
							p_observation = (p_aux[0].info['detail'] !== undefined && p_aux[0].info['detail']['pessoas'] !== undefined && parseInt(p_aux[0].info['detail']['pessoas']) > 1 ? p_aux[0].info['detail']['pessoas'] + ' x ' : '') + 'Aluguer de Pista'

							p_preco_unitario = parseFloat(f_aux[0].info.pista.price_s_vat)
							p_taxa_iva = f_aux[0].info.pista.taxe
							p_total_iliquido = parseFloat((parseFloat(p_preco_unitario)) * el.qtd)

							p_total_desconto = 0.00
							p_taxa_desconto_linha = 0.00
							p_total_iliquido_com_desconto = (parseFloat(p_total_iliquido) - parseFloat(p_taxa_desconto_linha))

							p_total_iva = (parseFloat(p_total_iliquido) * parseFloat(p_taxa_iva) * 0.01)
							p_total_com_iva = (parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva))

							p_total_iva_apresentado = (((parseFloat(f_aux[0].info.pista.price) - parseFloat(f_aux[0].info.pista.price_s_vat)) * parseInt(el.qtd))).toFixed(2)

							p_total_iliquido_apresentado = parseFloat(p_total_iliquido).toFixed(2)
							p_total_com_iva_apresentado = parseFloat(f_aux[0].info.pista.price).toFixed(2)

							p_total_aux += parseFloat(f_aux[0].info.pista.price) * parseInt(el.qtd)
							p_total_iliquido_documento += parseFloat(p_total_iliquido)
							p_total_iliquido_documento_com_deconto_linha_e_global += parseFloat(p_total_iliquido_com_desconto)
							
							p_total_liquido = parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva)

							prod_aux = {
								subname: p_subname,
								observation: p_observation,
								unidade: 'un',
								taxa_iva: p_taxa_iva,
								total_iva: parseFloat(p_total_iva),
								designacao: p_name,
								id_produto: p_id,
								quantidade: parseInt(el.qtd),
								aula_marcada: '',
								total_com_iva: parseFloat(p_total_com_iva),
								total_liquido: parseFloat(p_total_liquido),
								preco_unitario: parseFloat(p_preco_unitario),
								total_desconto: parseFloat(p_total_desconto),
								total_iliquido: parseFloat(p_total_iliquido),
								pretence_ao_produto: p_pretence_ao_produto,
								taxa_desconto_linha: parseFloat(p_taxa_desconto_linha),
								total_iva_apresentado: p_total_iva_apresentado,
								total_com_iva_apresentado: p_total_com_iva_apresentado,
								id_produto_na_lista_linhas: ++i,
								total_iliquido_apresentado: p_total_iliquido_apresentado,
								total_iliquido_com_desconto: parseFloat(p_total_iliquido_com_desconto),
								quantidade_aux_em_caso_de_aula: 0,
							}

							linhas_aux.push(prod_aux)

						}

					}

					if(p_aux[0].info['equipamento'].id !== '') {
						let e_aux = produtos.current.filter(el_p => el_p.id === p_aux[0].info['equipamento'].id)

						console.log('e_aux', e_aux)

						if(e_aux !== undefined && e_aux !== null && e_aux.length === 1) {

							p_id = e_aux[0].id
							p_subname = e_aux[0].info.name
							p_observation = (p_aux[0].info['detail'] !== undefined && p_aux[0].info['detail']['pessoas'] !== undefined && parseInt(p_aux[0].info['detail']['pessoas']) > 1 ? p_aux[0].info['detail']['pessoas'] + ' x ' : '') + e_aux[0].info.name

							p_preco_unitario = parseFloat(e_aux[0].info.value.price_s_vat)
							p_taxa_iva = e_aux[0].info.value.taxe

							p_total_iliquido = parseFloat((parseFloat(p_preco_unitario)) * el.qtd)
							if(p_aux[0].info['detail'] !== undefined && p_aux[0].info['detail']['pessoas'] !== undefined && parseInt(p_aux[0].info['detail']['pessoas']) > 1) {
								p_total_iliquido = parseFloat(p_total_iliquido) * parseInt(p_aux[0].info['detail']['pessoas'])
							}

							p_total_desconto = 0.00
							p_taxa_desconto_linha = 0.00
							p_total_iliquido_com_desconto = (parseFloat(p_total_iliquido) - parseFloat(p_taxa_desconto_linha))

							p_total_iva = (parseFloat(p_total_iliquido) * parseFloat(p_taxa_iva) * 0.01)
							p_total_com_iva = (parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva))
							if(p_aux[0].info['detail'] !== undefined && p_aux[0].info['detail']['pessoas'] !== undefined && parseInt(p_aux[0].info['detail']['pessoas']) > 1) {
								// p_total_com_iva = parseFloat(p_total_com_iva) * parseInt(p_aux[0].info['detail']['pessoas'])
							}

							p_total_iva_apresentado = (((parseFloat(e_aux[0].info.value.price) - parseFloat(e_aux[0].info.value.price_s_vat)) * parseInt(el.qtd))).toFixed(2)

							p_total_iliquido_apresentado = parseFloat(p_total_iliquido).toFixed(2)
							p_total_com_iva_apresentado = parseFloat(e_aux[0].info.value.price).toFixed(2)
							if(p_aux[0].info['detail'] !== undefined && p_aux[0].info['detail']['pessoas'] !== undefined && parseInt(p_aux[0].info['detail']['pessoas']) > 1) {
								p_total_com_iva_apresentado = (parseFloat(p_total_com_iva_apresentado) * parseInt(p_aux[0].info['detail']['pessoas'])).toFixed(2)
							}

							p_total_aux += parseFloat(e_aux[0].info.value.price) * parseInt(el.qtd)
							if(p_aux[0].info['detail'] !== undefined && p_aux[0].info['detail']['pessoas'] !== undefined && parseInt(p_aux[0].info['detail']['pessoas']) > 1) {
								p_total_aux = (parseFloat(p_total_aux) * parseInt(p_aux[0].info['detail']['pessoas'])).toFixed(2)
							}

							p_total_iliquido_documento += parseFloat(p_total_iliquido)
							if(p_aux[0].info['detail'] !== undefined && p_aux[0].info['detail']['pessoas'] !== undefined && parseInt(p_aux[0].info['detail']['pessoas']) > 1) {
								// p_total_iliquido_documento = (parseFloat(p_total_iliquido_documento) * parseInt(p_aux[0].info['detail']['pessoas'])).toFixed(2)
							}

							p_total_iliquido_documento_com_deconto_linha_e_global += parseFloat(p_total_iliquido_com_desconto)
							if(p_aux[0].info['detail'] !== undefined && p_aux[0].info['detail']['pessoas'] !== undefined && parseInt(p_aux[0].info['detail']['pessoas']) > 1) {
								// p_total_iliquido_documento_com_deconto_linha_e_global = (parseFloat(p_total_iliquido_documento_com_deconto_linha_e_global) * parseInt(p_aux[0].info['detail']['pessoas'])).toFixed(2)
							}
							
							p_total_liquido = parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva)
							
							prod_aux = {
								subname: p_subname,
								observation: p_observation,
								unidade: 'un',
								taxa_iva: p_taxa_iva,
								total_iva: parseFloat(p_total_iva),
								designacao: p_name,
								id_produto: p_id,
								quantidade: parseInt(el.qtd),
								aula_marcada: '',
								total_com_iva: parseFloat(p_total_com_iva),
								total_liquido: parseFloat(p_total_liquido),
								preco_unitario: parseFloat(p_preco_unitario),
								total_desconto: parseFloat(p_total_desconto),
								total_iliquido: parseFloat(p_total_iliquido),
								pretence_ao_produto: p_pretence_ao_produto,
								taxa_desconto_linha: parseFloat(p_taxa_desconto_linha),
								total_iva_apresentado: p_total_iva_apresentado,
								total_com_iva_apresentado: p_total_com_iva_apresentado,
								id_produto_na_lista_linhas: ++i,
								total_iliquido_apresentado: p_total_iliquido_apresentado,
								total_iliquido_com_desconto: parseFloat(p_total_iliquido_com_desconto),
								quantidade_aux_em_caso_de_aula: 0,
							}

							linhas_aux.push(prod_aux)

						}
						
					}

					if(p_aux[0].info['aula'].id !== '') {
						let a_aux = produtos.current.filter(el_p => el_p.id === p_aux[0].info['aula'].id)

						console.log('a_aux', a_aux)

						if(a_aux !== undefined && a_aux !== null && a_aux.length === 1) {

							p_id = a_aux[0].id
							p_subname = a_aux[0].info.name
							p_observation = a_aux[0].info.name

							p_preco_unitario = parseFloat(a_aux[0].info.value.price_s_vat)
							p_taxa_iva = a_aux[0].info.value.taxe
							p_total_iliquido = parseFloat((parseFloat(p_preco_unitario)) * el.qtd)

							p_total_desconto = 0.00
							p_taxa_desconto_linha = 0.00
							p_total_iliquido_com_desconto = (parseFloat(p_total_iliquido) - parseFloat(p_taxa_desconto_linha))

							p_total_iva = (parseFloat(p_total_iliquido) * parseFloat(p_taxa_iva) * 0.01)
							p_total_com_iva = (parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva))

							p_total_iva_apresentado = (((parseFloat(a_aux[0].info.value.price) - parseFloat(a_aux[0].info.value.price_s_vat)) * parseInt(el.qtd))).toFixed(2)

							p_total_iliquido_apresentado = parseFloat(p_total_iliquido).toFixed(2)
							p_total_com_iva_apresentado = parseFloat(a_aux[0].info.value.price).toFixed(2)

							p_total_aux += parseFloat(a_aux[0].info.value.price) * parseInt(el.qtd)
							p_total_iliquido_documento += parseFloat(p_total_iliquido)
							p_total_iliquido_documento_com_deconto_linha_e_global += parseFloat(p_total_iliquido_com_desconto)
							
							p_total_liquido = parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva)

							let n_aulas = 0
							if(a_aux[0].info.value['alunos'] !== undefined && a_aux[0].info.value['alunos'] !== null) {
								if(parseInt(a_aux[0].info.value['alunos']) > 0) {
									n_aulas = parseInt(a_aux[0].info.value['alunos'])
								}
							}

							prod_aux = {
								subname: p_subname,
								observation: p_observation,
								unidade: 'un',
								taxa_iva: p_taxa_iva,
								total_iva: parseFloat(p_total_iva),
								designacao: p_name,
								id_produto: p_id,
								quantidade: parseInt(el.qtd),
								aula_marcada: '',
								total_com_iva: parseFloat(p_total_com_iva),
								total_liquido: parseFloat(p_total_liquido),
								preco_unitario: parseFloat(p_preco_unitario),
								total_desconto: parseFloat(p_total_desconto),
								total_iliquido: parseFloat(p_total_iliquido),
								pretence_ao_produto: p_pretence_ao_produto,
								taxa_desconto_linha: parseFloat(p_taxa_desconto_linha),
								total_iva_apresentado: p_total_iva_apresentado,
								total_com_iva_apresentado: p_total_com_iva_apresentado,
								id_produto_na_lista_linhas: ++i,
								total_iliquido_apresentado: p_total_iliquido_apresentado,
								total_iliquido_com_desconto: parseFloat(p_total_iliquido_com_desconto),
								quantidade_aux_em_caso_de_aula: n_aulas,
							}

							p_tem_aulas = true
							linhas_aux.push(prod_aux)

						}

					}

				}
				else {
					prod_aux = {}
					p_subname = ''
					p_observation = ''

					if(p_aux[0].info['type'] !== undefined && p_aux[0].info['type'] !== null && p_aux[0].info['type'] === 'forfait') {

						// let f_aux = produtos.current.filter(el_p => el_p.id === p_aux[0].info.id)
						let f_aux = p_aux

						console.log('f_aux', f_aux)

						if(f_aux !== undefined && f_aux !== null && f_aux.length === 1) {

							// FORFAIT
							p_id = f_aux[0].id
							p_subname = f_aux[0].info.name + (f_aux[0].info.category !== '' ? ' - ' + f_aux[0].info.category : '')

							p_preco_unitario = parseFloat(f_aux[0].info.forfait.price_s_vat)
							p_taxa_iva = f_aux[0].info.forfait.taxe
							p_total_iliquido = parseFloat((parseFloat(p_preco_unitario)) * el.qtd)

							p_total_desconto = 0.00
							p_taxa_desconto_linha = 0.00
							p_total_iliquido_com_desconto = (parseFloat(p_total_iliquido) - parseFloat(p_taxa_desconto_linha))

							p_total_iva = (parseFloat(p_total_iliquido) * parseFloat(p_taxa_iva) * 0.01)
							p_total_com_iva = (parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva))

							p_total_iva_apresentado = (((parseFloat(f_aux[0].info.forfait.price) - parseFloat(f_aux[0].info.forfait.price_s_vat)) * parseInt(el.qtd))).toFixed(2)

							p_total_iliquido_apresentado = parseFloat(p_total_iliquido).toFixed(2)
							p_total_com_iva_apresentado = parseFloat(f_aux[0].info.forfait.price).toFixed(2)

							p_total_aux += parseFloat(f_aux[0].info.forfait.price) * parseInt(el.qtd)
							p_total_iliquido_documento += parseFloat(p_total_iliquido)
							p_total_iliquido_documento_com_deconto_linha_e_global += parseFloat(p_total_iliquido_com_desconto)
							
							p_total_liquido = parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva)

							prod_aux = {
								subname: '',
								observation: p_observation,
								unidade: 'un',
								taxa_iva: p_taxa_iva,
								total_iva: parseFloat(p_total_iva),
								designacao: p_name,
								id_produto: p_id,
								quantidade: parseInt(el.qtd),
								aula_marcada: '',
								total_com_iva: parseFloat(p_total_com_iva),
								total_liquido: parseFloat(p_total_liquido),
								preco_unitario: parseFloat(p_preco_unitario),
								total_desconto: parseFloat(p_total_desconto),
								total_iliquido: parseFloat(p_total_iliquido),
								pretence_ao_produto: p_pretence_ao_produto,
								taxa_desconto_linha: parseFloat(p_taxa_desconto_linha),
								total_iva_apresentado: p_total_iva_apresentado,
								total_com_iva_apresentado: p_total_com_iva_apresentado,
								id_produto_na_lista_linhas: ++i,
								total_iliquido_apresentado: p_total_iliquido_apresentado,
								total_iliquido_com_desconto: parseFloat(p_total_iliquido_com_desconto),
								quantidade_aux_em_caso_de_aula: 0,
							}

							linhas_aux.push(prod_aux)

							// ALUGUE DE PISTA
							p_id = '90'
							p_subname = ''

							p_preco_unitario = parseFloat(f_aux[0].info.pista.price_s_vat)
							p_taxa_iva = f_aux[0].info.pista.taxe
							p_total_iliquido = parseFloat((parseFloat(p_preco_unitario)) * el.qtd)

							p_total_desconto = 0.00
							p_taxa_desconto_linha = 0.00
							p_total_iliquido_com_desconto = (parseFloat(p_total_iliquido) - parseFloat(p_taxa_desconto_linha))

							p_total_iva = (parseFloat(p_total_iliquido) * parseFloat(p_taxa_iva) * 0.01)
							p_total_com_iva = (parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva))

							p_total_iva_apresentado = (((parseFloat(f_aux[0].info.pista.price) - parseFloat(f_aux[0].info.pista.price_s_vat)) * parseInt(el.qtd))).toFixed(2)

							p_total_iliquido_apresentado = parseFloat(p_total_iliquido).toFixed(2)
							p_total_com_iva_apresentado = parseFloat(f_aux[0].info.pista.price).toFixed(2)

							p_total_aux += parseFloat(f_aux[0].info.pista.price) * parseInt(el.qtd)
							p_total_iliquido_documento += parseFloat(p_total_iliquido)
							p_total_iliquido_documento_com_deconto_linha_e_global += parseFloat(p_total_iliquido_com_desconto)
							
							p_total_liquido = parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva)

							prod_aux = {
								subname: '',
								observation: p_observation,
								unidade: 'un',
								taxa_iva: p_taxa_iva,
								total_iva: parseFloat(p_total_iva),
								designacao: 'Aluguer de Pista',
								id_produto: p_id,
								quantidade: parseInt(el.qtd),
								aula_marcada: '',
								total_com_iva: parseFloat(p_total_com_iva),
								total_liquido: parseFloat(p_total_liquido),
								preco_unitario: parseFloat(p_preco_unitario),
								total_desconto: parseFloat(p_total_desconto),
								total_iliquido: parseFloat(p_total_iliquido),
								pretence_ao_produto: p_pretence_ao_produto,
								taxa_desconto_linha: parseFloat(p_taxa_desconto_linha),
								total_iva_apresentado: p_total_iva_apresentado,
								total_com_iva_apresentado: p_total_com_iva_apresentado,
								id_produto_na_lista_linhas: ++i,
								total_iliquido_apresentado: p_total_iliquido_apresentado,
								total_iliquido_com_desconto: parseFloat(p_total_iliquido_com_desconto),
								quantidade_aux_em_caso_de_aula: 0,
							}

							linhas_aux.push(prod_aux)

						}

					}
					else {

						if(p_aux !== undefined && p_aux !== null && p_aux.length === 1) {

							p_id = p_aux[0].id
							p_subname = ''

							p_preco_unitario = parseFloat(p_aux[0].info.value.price_s_vat)
							p_taxa_iva = p_aux[0].info.value.taxe
							p_total_iliquido = parseFloat((parseFloat(p_preco_unitario)) * el.qtd)

							p_total_desconto = 0.00
							p_taxa_desconto_linha = 0.00
							p_total_iliquido_com_desconto = (parseFloat(p_total_iliquido) - parseFloat(p_taxa_desconto_linha))

							p_total_iva = (parseFloat(p_total_iliquido) * parseFloat(p_taxa_iva) * 0.01)
							p_total_com_iva = (parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva))

							p_total_iva_apresentado = (((parseFloat(p_aux[0].info.value.price) - parseFloat(p_aux[0].info.value.price_s_vat)) * parseInt(el.qtd))).toFixed(2)

							p_total_iliquido_apresentado = parseFloat(p_total_iliquido).toFixed(2)
							p_total_com_iva_apresentado = parseFloat(p_aux[0].info.value.price).toFixed(2)

							p_total_aux += parseFloat(p_aux[0].info.value.price) * parseInt(el.qtd)
							p_total_iliquido_documento += parseFloat(p_total_iliquido)
							p_total_iliquido_documento_com_deconto_linha_e_global += parseFloat(p_total_iliquido_com_desconto)
							
							p_total_liquido = parseFloat(p_total_iliquido_com_desconto) + parseFloat(p_total_iva)

							let n_aulas = 0
							if(p_aux[0].info.value['alunos'] !== undefined && p_aux[0].info.value['alunos'] !== null) {
								if(parseInt(p_aux[0].info.value['alunos']) > 0) {
									n_aulas = parseInt(p_aux[0].info.value['alunos'])
								}

								p_name = p_aux[0].info.name + ' - ' + p_aux[0].info.category
								p_observation = p_aux[0].info.observation
							}

							prod_aux = {
								subname: p_subname,
								observation: p_observation,
								unidade: 'un',
								taxa_iva: p_taxa_iva,
								total_iva: parseFloat(p_total_iva),
								designacao: p_name,
								id_produto: p_id,
								quantidade: parseInt(el.qtd),
								aula_marcada: '',
								total_com_iva: parseFloat(p_total_com_iva),
								total_liquido: parseFloat(p_total_liquido),
								preco_unitario: parseFloat(p_preco_unitario),
								total_desconto: parseFloat(p_total_desconto),
								total_iliquido: parseFloat(p_total_iliquido),
								pretence_ao_produto: p_pretence_ao_produto,
								taxa_desconto_linha: parseFloat(p_taxa_desconto_linha),
								total_iva_apresentado: p_total_iva_apresentado,
								total_com_iva_apresentado: p_total_com_iva_apresentado,
								id_produto_na_lista_linhas: ++i,
								total_iliquido_apresentado: p_total_iliquido_apresentado,
								total_iliquido_com_desconto: parseFloat(p_total_iliquido_com_desconto),
								quantidade_aux_em_caso_de_aula: n_aulas,
							}

							linhas_aux.push(prod_aux)

						}

					}

				}

			}

		})

		order.current.info.documento.taxa_desconto_global = parseFloat(p_taxa_desconto_global).toFixed(2)
		order.current.info.documento.total_desconto_linha_documento = parseFloat(p_total_desconto_linha_documento).toFixed(2)
		order.current.info.documento.total_iva_documento = parseFloat(get_total_iva_documento(linhas_aux)).toFixed(3)
		order.current.info.documento.total_documento = parseFloat(p_total_aux).toFixed(2)
		order.current.info.documento.total_iliquido_documento = parseFloat(p_total_iliquido_documento).toFixed(2)
		order.current.info.documento.valor_desconto_global_a_aplicar = (parseFloat(p_total_desconto_linha_documento) + parseFloat(p_taxa_desconto_global)).toFixed(2)
		order.current.info.documento.total_iliquido_documento_com_deconto_linha_e_global = parseFloat(parseFloat(p_total_iliquido_documento_com_deconto_linha_e_global).toFixed(2))
		order.current.info.documento.linhas = linhas_aux
		order.current.info.tem_aulas = p_tem_aulas
		order.current.info.pagamento_pendente = 0

		// console.log('order.current', order.current)
		// return

		Swal.fire({
			title: language[lang].insert_title,
			text: language[lang].insert_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].insert_confirm,
			cancelButtonText: language[lang].insert_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqPOST(api_crud_route, order.current)
					.then(() => { 

						let reponse_aux = {
							key: order.current.info.id_usado_para_gerar_pagamento, 
							type: 'oferta', 
							status: 'success', 
							ref: '', 
							data: order.current.info.data, 
							response: {
								id: order.current.info.id_usado_para_gerar_pagamento, 
								obj: {
									response: {
										method: {
											type: "oferta", 
											status: "success"
										}, 
										status: "ok", 
										message: ["Your request was successfully created"], 
									}
								}, 
								companycode: getTokenInfo().companycode
							}
						}

						reqPOST(`${api_crud_base}/store/payment/notification/status2`, reponse_aux)
							.then(() => { 
						
								let id_pagamento2 = Date.now() + '' + props.location.state.item['id']
								set_dados(order.current.info['id_usado_para_gerar_pagamento'] = parseInt(id_pagamento2))

								// props.history.push(endpoints.list) 

							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					})
					.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
			}
		})

	}

	const handle_change_info = (e) => {
		const { name, value, dataset } = e.target;
		const { lang, langid } = dataset

		if (langid === '1') {
			set_dados(dados.current.info[name] = value)
		}
		else {
			if (dados.current.info['language'] === undefined)
				dados.current.info['language'] = []

			if (dados.current.info.language.length === 0) {
				dados.current.info.language[langid] = { id: langid, code: lang, name: '', description: '' }
			}

			set_dados(dados.current.info['language'][langid][name] = value)
		}

		if(name === 'bgColor')
			set_dados(dados.current.info.borderColor = value)

		console.log('name', name)
		console.log('value', value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const add_product = (type, el) => {
		let name = el.info.name + ' ' + (el.info.category !== '' ? '(' + el.info.category + ')' : '')

		let aux = selected_products
		let x = aux.filter(el_p => el_p.id === el.id)
		if(x.length > 0) {
			x.forEach(el_p => {
				if(el_p.id === el.id) {
					el_p.qtd++
				}
			})
		}
		else {
			aux.push({id: el.id, name: name, qtd: 1})
		}
		set_selected_products(aux)

		setRefresh(refresh + 1)
	}

	const remove_product = (index) => {

		let aux = []
		selected_products.forEach((el, k) => {
			if(k !== parseInt(index)) {
				aux.push(el)
			}
		})
		set_selected_products(aux)

		setRefresh(refresh + 1)
	}

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].component}</h2>
					<p>{language[lang].component} / {dados.current.id !== '' ? language[lang].component_edit : language[lang].component_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
		
							<div className="mb-5 mb-xl-10">
								<div className='card'>

									<div className="card-header border-0 d-flex justify-content-sm-between">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].component_new}</h3>
										</div>
										<div className="card-toolbar">
											<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0 d-none">
												{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<li key={k_lang} className="nav-item">
																	<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
																</li>
															)
														})
														:
														''
												}
											</ul>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">
												<div className='tab-content'>
													{
													content_language.length > 1 ?
														content_language.map((el_lang, k_lang) => {
															return (
																<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"tab_pane_info_language_" + k_lang} role="tabpanel">
																	
																	<div className="row m-3">
																		<div className="col-12 col-sm-6">
																			<div className='row'>
																				<div className='col-12'>
																					<label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_name}</label>
																					{dados.current.info.name}
																				</div>
																				<div className="col-12">
																					<label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_vat}</label>
																					{dados.current.info.vat}
																				</div>
																				<div className="col-12">
																					<label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_email}</label>
																					{dados.current.info.email}
																				</div>
																			</div>

																			<div className="row my-3">
																				<div className="col-12 col-sm-8">
																					<label className="fs-6 fw-bold mb-2">{language[lang].field_observation} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>

																					<textarea className="form-control" type="description" name="description" value={dados.current.info.description} placeholder={language[lang].field_observation_placeholder} onChange={handle_change_info} />
																				</div>
																			</div>
																		</div>
																		<div className="col-12 col-sm-6">
																			<div className='row'>
																				<div className='col-12'>
																					<label className="fs-6 fw-bold mb-2 me-4">{language[lang].product_list}</label>
																				</div>
																			</div>

																			<div className="row my-3">
																				<div className="col-12">
																					{
																					selected_products.map((el_sp, k_sp) => {
																						return (
																							<div key={k_sp}>
																								<button type="button" className="btn btn-secondary rounded-0 my-2" onClick={() => remove_product(k_sp)}>
																									{el_sp.name} ({el_sp.qtd}) <i className="bi bi-x-lg text-white"></i>
																								</button>
																							</div>
																						)
																					})
																					}
																				</div>
																			</div>
																		</div>
																	</div>
																	
																	<div className="row m-3">
																		<div className='col-12'>
																			<div className='row'>
																				<div className='col-6 col-md-4 mb-5'>
																					<div className=''>
																						<label className="fs-6 fw-bold mb-2 me-4">{language[lang].forfaits}</label>
																					</div>
																					{
																					forfaits.current !== undefined && forfaits.current !== null && forfaits.current.length > 0 ?
																						forfaits.current.map((el_f, k_f) => {
																							return (
																								<div key={k_f}>
																									<button type="button" className="btn btn-secondary rounded-0 my-2" onClick={() => add_product('0', el_f)}>
																										{el_f.info.name} {el_f.info.category !== '' ? '(' + el_f.info.category + ')' : ''} <i className="bi bi-plus-lg text-white"></i>
																									</button>
																								</div>
																							)
																						})
																					:
																						null
																					}
																				</div>
																				<div className='col-6 col-md-4 mb-5'>
																					<div className=''>
																						<label className="fs-6 fw-bold mb-2 me-4">{language[lang].aulas}</label>
																					</div>
																					{
																					aulas.current !== undefined && aulas.current !== null && aulas.current.length > 0 ?
																						aulas.current.map((el_a, k_a) => {
																							return (
																								<div key={k_a}>
																									<button type="button" className="btn btn-secondary rounded-0 my-2" onClick={() => add_product('1', el_a)}>
																										{el_a.info.name} {el_a.info.category !== '' ? '(' + el_a.info.category + ')' : ''} <i className="bi bi-plus-lg text-white"></i>
																									</button>
																								</div>
																							)
																						})
																					:
																						null
																					}
																				</div>
																				<div className='col-6 col-md-4 mb-5'>
																					<div className=''>
																						<label className="fs-6 fw-bold mb-2 me-4">{language[lang].atividades}</label>
																					</div>
																					{
																					atividades.current !== undefined && atividades.current !== null && atividades.current.length > 0 ?
																						atividades.current.map((el_at, k_at) => {
																							if(el_at.id !== '90') {
																								return (
																									<div key={k_at}>
																										<button type="button" className="btn btn-secondary rounded-0 my-2" onClick={() => add_product('2', el_at)}>
																											{el_at.info.name} {el_at.info.category !== '' ? '(' + el_at.info.category + ')' : ''} <i className="bi bi-plus-lg text-white"></i>
																										</button>
																									</div>
																								)
																							}
																							else {
																								return null
																							}
																						})
																					:
																						null
																					}
																				</div>
																				<div className='col-6 col-md-4 mb-5'>
																					<div className=''>
																						<label className="fs-6 fw-bold mb-2 me-4">{language[lang].equipamentos}</label>
																					</div>
																					{
																					equipamentos.current !== undefined && equipamentos.current !== null && equipamentos.current.length > 0 ?
																						equipamentos.current.map((el_e, k_e) => {
																							return (
																								<div key={k_e}>
																									<button type="button" className="btn btn-secondary rounded-0 my-2" onClick={() => add_product('3', el_e)}>
																										{el_e.info.name} {el_e.info.category !== '' ? '(' + el_e.info.category + ')' : ''} <i className="bi bi-plus-lg text-white"></i>
																									</button>
																								</div>
																							)
																						})
																					:
																						null
																					}
																				</div>
																				<div className='col-6 col-md-8 mb-5'>
																					<div className=''>
																						<label className="fs-6 fw-bold mb-2 me-4">{language[lang].packs}</label>
																					</div>
																					{
																					packs.current !== undefined && packs.current !== null && packs.current.length > 0 ?
																						packs.current.map((el_p, k_p) => {
																							return (
																								<div key={k_p}>
																									<button type="button" className="btn btn-secondary rounded-0 my-2" onClick={() => add_product('4', el_p)}>
																										{el_p.info.name} {el_p.info.category !== '' ? '(' + el_p.info.category + ')' : ''} <i className="bi bi-plus-lg text-white"></i>
																									</button>
																								</div>
																							)
																						})
																					:
																						null
																					}
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															)
														})
													:
														null
													}
												</div>
											</div>
										</form>
									</div>

								</div>
							</div>

						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
